var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { RouterConstants } from '../../../configuration/router.constants';
import { BaseTemplate } from './base-template';
import { BundleKeyHelper, TemplateType } from '../../../services/modules/brand-client.service';
import { computedFrom } from 'aurelia-binding';
var BaseBundles = /** @class */ (function (_super) {
    __extends(BaseBundles, _super);
    function BaseBundles(lotteryClientService, router, tokenClient, i18n, dialogClient, configClientService) {
        var _this = _super.call(this, router, i18n, lotteryClientService, dialogClient, tokenClient) || this;
        _this.lotteryClientService = lotteryClientService;
        _this._bundles = [];
        _this.bundleComboBoxItems = [];
        _this.animating = false;
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        _this.configClientService = configClientService;
        return _this;
    }
    Object.defineProperty(BaseBundles.prototype, "bundles", {
        get: function () {
            return this._bundles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseBundles.prototype, "selectedBundleId", {
        get: function () {
            return this._selectedBundleId;
        },
        set: function (x) {
            if (this._selectedBundleId == x)
                return;
            this._selectedBundleId = x;
        },
        enumerable: false,
        configurable: true
    });
    BaseBundles.prototype.navigateToBundle = function (bundle) {
        this.router.navigateToRoute(RouterConstants.RouteNames.Bundle, {
            key: BundleKeyHelper.getKey(bundle.name),
            bundleId: bundle.bundleId
        });
    };
    BaseBundles.prototype.format = function (price) {
        if (price)
            return price.toFixed(2);
        return 0.00;
    };
    BaseBundles.prototype.detached = function () {
        _super.prototype.detached.call(this);
        if (this._intervalDrawDateChecker) {
            this._intervalDrawDateChecker = null;
        }
    };
    BaseBundles.prototype.getAllResults = function () {
        return false;
    };
    BaseBundles.prototype.activate = function (params) {
        var _this = this;
        var promise = _super.prototype.activate.call(this, params);
        this.lotteryClientService.getLobbyBundles({}).then(function (x) {
            _this._bundles = x;
            _this.bundleComboBoxItems = [{ bundleName: _this.i18n.tr("bundles-page-all-bundles-label"), bundleId: null }].concat(x.map(function (z) { return ({ bundleId: z.bundleId, bundleName: z.name }); }));
        }, function (x) {
        });
        return promise;
    };
    BaseBundles.prototype.getConfig = function (page, config) {
        return __awaiter(this, void 0, void 0, function () {
            var json, bob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Config)];
                    case 1:
                        json = _a.sent();
                        bob = json[TemplateType.Config][page][config];
                        return [2 /*return*/, bob];
                }
            });
        });
    };
    __decorate([
        computedFrom("_bundles"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseBundles.prototype, "bundles", null);
    __decorate([
        computedFrom("_selectedBundleId"),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], BaseBundles.prototype, "selectedBundleId", null);
    return BaseBundles;
}(BaseTemplate));
export { BaseBundles };
